import state from "./moduleVisitPointState.js";
import mutations from "./moduleVisitPointMutations.js";
import actions from "./moduleVisitPointActions.js";
import getters from "./moduleVisitPointGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
